import { TDeviceType, useDeviceType as useUiKitDeviceType } from '@cian/ui-kit';
import { ComponentClass, FC } from 'react';

interface IAdaptiveContainerProps {
  desktop: FC | ComponentClass;
  mobile: FC | ComponentClass;
  useDeviceType?: () => TDeviceType;
}

export const AdaptiveContainer: FC<IAdaptiveContainerProps> = ({
  desktop: DesktopContainer,
  mobile: MobileContainer,
  useDeviceType = useUiKitDeviceType,
}) => {
  const deviceType = useDeviceType();

  const Container = deviceType === 'desktop' ? DesktopContainer : MobileContainer;

  return <Container />;
};
